import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=45839edf&scoped=true"
import script from "./DeliveryOrder.vue?vue&type=script&lang=js"
export * from "./DeliveryOrder.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOrder.vue?vue&type=style&index=0&id=45839edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45839edf",
  null
  
)

export default component.exports